module.exports = __webpack_public_path__ + "RobotoMedium.1da84aa447fada7ba947.ttf";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoMedium.ttf
// module id = ../../../../../src/fonts/RobotoMedium.ttf
// module chunks = 3